import { orderService } from '@grc/ui-shared/lib/components/common/constants/constants';
import notify from '../../common/notify';

const getOrderDetails = async (
  orderId: string,
  url: string,
  fetchData: any
) => {
  if (!orderId) return null;

  const getOrderByIdUrl = url.replace('orderId', orderId);

  try {
    const response = await fetchData(getOrderByIdUrl, notify, orderService);

    if (response?.status === 200) {
      return response.data;
    }

    return null;
  } catch (err) {
    console.error('Error fetching order details:', err);
    return null;
  }
};

export default getOrderDetails;
